var _ellipse, _ellipse2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34,
    cy: 33.8109,
    rx: 34,
    ry: 33.4237,
    fill: "#D0FFEF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.6139,
    cy: 34.5027,
    rx: 29.6002,
    ry: 29.0985,
    fill: "#33D69F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9911 33.0728L25.1686 29.8954L33.9065 38.6333L39.467 33.0728L44.2331 37.8389V23.3816H21.9911V33.0728ZM20.4024 20.2042H45.8218C46.2432 20.2042 46.6473 20.3716 46.9452 20.6695C47.2432 20.9675 47.4105 21.3716 47.4105 21.7929V47.2123C47.4105 47.6337 47.2432 48.0378 46.9452 48.3357C46.6473 48.6337 46.2432 48.801 45.8218 48.801H20.4024C19.9811 48.801 19.577 48.6337 19.279 48.3357C18.9811 48.0378 18.8137 47.6337 18.8137 47.2123V21.7929C18.8137 21.3716 18.9811 20.9675 19.279 20.6695C19.577 20.3716 19.9811 20.2042 20.4024 20.2042ZM38.6726 31.3252C38.0406 31.3252 37.4345 31.0741 36.9875 30.6272C36.5406 30.1803 36.2896 29.5742 36.2896 28.9421C36.2896 28.3101 36.5406 27.704 36.9875 27.2571C37.4345 26.8101 38.0406 26.5591 38.6726 26.5591C39.3047 26.5591 39.9108 26.8101 40.3577 27.2571C40.8046 27.704 41.0557 28.3101 41.0557 28.9421C41.0557 29.5742 40.8046 30.1803 40.3577 30.6272C39.9108 31.0741 39.3047 31.3252 38.6726 31.3252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryMenu);
export default __webpack_public_path__ + "static/media/gallery-menu.098545f8fa1a0598aaebca2c36c80e5f.svg";
export { ForwardRef as ReactComponent };